import { flux } from '@/core/flux.module';
import type { SourceScalingTableFilterModel } from '@/tableDefinitionEditor/sourceScalingTableFilter.types';
import type { HierarchyOutputV1 } from '@seeqdev/api/model/HierarchyOutputV1';

export const setAliasColumnId = (aliasColumnId?: string) =>
  flux.dispatch('ASSET_BUILDER_SET_ALIAS_COLUMN_ID', { aliasColumnId });

export const setHierarchyOutput = (hierarchyOutput?: HierarchyOutputV1) =>
  flux.dispatch('ASSET_BUILDER_SET_HIERARCHY_OUTPUT', { hierarchyOutput });

export const resetAssetBuilder = () => flux.dispatch('ASSET_BUILDER_RESET');

export const setSourceScalingTableFilter = (sourceScalingTableFilter: SourceScalingTableFilterModel | null) =>
  flux.dispatch('ASSET_BUILDER_SET_SOURCE_SCALING_TABLE_FILTER', { sourceScalingTableFilter });

export const setName = (name: string) => flux.dispatch('ASSET_BUILDER_SET_NAME', { name });

export const setDescription = (description: string | undefined) =>
  flux.dispatch('ASSET_BUILDER_SET_DESCRIPTION', { description });

export const setRowGroupColumnIds = (rowGroupColumnIds: string[]) =>
  flux.dispatch('ASSET_BUILDER_SET_ROW_GROUP_COLUMN_IDS', { rowGroupColumnIds });

export const addRowGroupColumn = (columnId: string) =>
  flux.dispatch('ASSET_BUILDER_ADD_ROW_GROUP_COLUMN', { columnId });

export const removeRowGroupColumn = (columnId: string) =>
  flux.dispatch('ASSET_BUILDER_REMOVE_ROW_GROUP_COLUMN', { columnId });

export const reorderRowGroupColumns = (fromIndex: number, toIndex: number) =>
  flux.dispatch('ASSET_BUILDER_REORDER_ROW_GROUP_COLUMNS', { fromIndex, toIndex });

export const bumpHierarchyListRevision = () => flux.dispatch('ASSET_BUILDER_BUMP_HIERARCHY_LIST_REVISION');
